import i18next from 'i18next'
import lang from "./locale/lang"
import cookies from 'react-cookies'

i18next.init({
  interpolation: {
    escapeValue: false
  },
  lng: cookies.load('lang') || "ja",
  resources: lang
})
export default i18next
